import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import DelayedContent from "./components/DelayedContent";
import NotFound from "./pages/NotFound";
import ConfidaysLoader from "./components/ConfidaysLoader";
// Pages
import Home from "./pages/Home";
import About from "./pages/About";
import Categories from "./pages/Categories";
import Products from "./pages/Products";
import Blog from "./pages/Blog";
import Careers from "./pages/Careers";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import BlogDetails from "./pages/BlogDetails";
import BlogSection from "./pages/BlogSelection";
import ProductPage from "./pages/ProductPage";
import DistributorsForm from "./pages/DistributorsForm";
import Register from "./pages/RegisterPage";
import CartPage from "./pages/CartPage";
import ForgotPassword from "./auth/ForgotPassword";
import VerifyOtp from "./auth/VerifyOtp";
import ResetPassword from "./auth/ResetPassword";
import ScrollToTop from "./components/ScrollToTop";
// import TelemetryTracker from "./components/TelemetryTracker";
// Dashboard
import ProtectedRoute from "./routes/ProtectedRoute";
import DashboardHome from "./dashboard/DashboardHome";
import Orders from "./dashboard/Orders";
import Wishlist from "./dashboard/Wishlist";
import Profile from "./dashboard/Profile";
import Address from "./dashboard/Address";
import OrderDetails from "./dashboard/OrderDetails";

import { Toaster } from "react-hot-toast";
import PrivacyPolicy from "./pages/privacy";
import TermsOfUse from "./pages/terms";
import PaymentsHistory from "./dashboard/paymenthistory";
import TrackOrders from "./dashboard/TrackOrders";
import OrderSuccess from "./pages/Ordersuccess";

export default function App() {
  const [loading, setLoading] = useState(true);
return (
  <>
    {/* LOADER */}
    {loading && <ConfidaysLoader onFinish={() => setLoading(false)} />}

    {/* WEBSITE */}
    {!loading && (
      <BrowserRouter>
      <ScrollToTop />
      {/* <TelemetryTracker /> */}
        <Toaster position="bottom-right" />

        {/* HEADER */}
        <Header />

        <Routes>
          {/* PUBLIC ROUTES */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/categories/*" element={<Categories />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductPage />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetails />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<PrivacyPolicy/>} />
                  <Route path="/terms" element={<TermsOfUse/>} />
          <Route path="/distributors" element={<DistributorsForm />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/verify-otp" element={<VerifyOtp />} />
          <Route path="/reset-password" element={<ResetPassword />} />
   <Route path="/order-success" element={<OrderSuccess/>} />
          {/* DASHBOARD */}
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard" element={<DashboardHome />} />
            <Route path="/dashboard/purchase-history" element={<Orders />} />
            <Route
              path="/dashboard/purchase-history/order/:id"
              element={<OrderDetails />}
            />
            <Route path="/dashboard/wishlist" element={<Wishlist />} />
            <Route path="/dashboard/profile" element={<Profile />} />
            <Route path="/dashboard/addresses" element={<Address />} />
             <Route path="/dashboard/track-orders" element={<TrackOrders/>} />
              <Route path="/dashboard/payments" element={<PaymentsHistory/>} />
          </Route>

          {/* 404 */}
          <Route path="*" element={<NotFound />} />
        </Routes>

        {/* FOOTER */}
        <Footer />
      </BrowserRouter>
    )}
  </>
);
}
